import CategoriesPageRouteHandler from '../pages/categories/CategoriesPageRouteHandler';
import CollectionPageRouteHandler from '../pages/collections/CollectionPageRouteHandler';
import HomePageRouteHandler from './components/AddonDiscoveryRoutes/components/HomePageRouteHandler';
import SearchResultPageRouteHandler from './components/AddonDiscoveryRoutes/components/SearchResultPageRouteHandler';

export function getAetherRoutes() {
  return [
    {
      name: 'homeScreen',
      path: '/',
      exact: true,
      component: HomePageRouteHandler,
      showAetherNavAndFooter: true,
      hideSearchIconOnAetherNav: true,
    },
    {
      name: 'searchScreen',
      path: '/search',
      exact: true,
      component: SearchResultPageRouteHandler,
      showAetherNavAndFooter: true,
      hideSearchIconOnAetherNav: true,
    },
    {
      name: 'productHomeScreen',
      path: '/product/:productId',
      exact: true,
      component: HomePageRouteHandler,
      showAetherNavAndFooter: true,
    },
    {
      name: 'categoriesScreen',
      path: '/categories/:categoryId',
      exact: true,
      component: CategoriesPageRouteHandler,
      showAetherNavAndFooter: true,
    },
    {
      exact: true,
      name: 'collectionScreen',
      path: '/collections/:collectionName',
      component: CollectionPageRouteHandler,
      showAetherNavAndFooter: true,
    },
  ];
}
